import MapperBase from '../MapperBase.js';
import { ChartSeries } from '../../entities/index.js';

/**
 * @see https://plotly.com/javascript/reference/heatmap/
 */
class PlotlyHeatmapSeriesMapper extends MapperBase {
    constructor(silent, fallback, seriesBase) {
        super(silent, fallback);

        if (typeof(seriesBase) !== 'undefined') {
            if (typeof(seriesBase) !== 'object') {
                throw new TypeError('seriesBase must be an object');
            }

            this.seriesBase = seriesBase;
        }
        else {
            this.seriesBase = {};
        }
    }

    map(item) {
        if (!(item instanceof ChartSeries)) {
            throw new TypeError('item must be an instance inheriting from Series class');
        }

        // https://plotly.com/javascript/reference/heatmap/#heatmap-z
        const z = [];
        const sources = [];

        // only if we have 3 dimensional data https://plotly.com/javascript/heatmaps/#heatmap-with-categorical-axis-labels
        // https://plotly.com/javascript/reference/heatmap/#heatmap-x
        const x = [];
        // https://plotly.com/javascript/reference/heatmap/#heatmap-y
        const y = [];

        let firstDimension = null;

        for (let s = 0; s < item.length; s++) {
            const series = item[s];

            if (series.dimensions !== 3 && series.dimensions !== 1) {
                throw new Error(`only three and one dimensional series are supported, error at series index ${s}`);
            }
            
            if (s === 0){
                firstDimension = series.dimensions;
            }
            else if (firstDimension !== series.dimensions) {
                throw new Error(`all series must have the same dimension, error at series index ${s}`);
            }

            if (!series.length){
                continue;
            }

            if (series.dimensions == 3) {
                if (s === 0){
                    x.push.apply(x, series.getDimension(1));
                }
               
                y.push(series[0][1]);
            }

            z.push(series.getDimension(series.dimensions));
            sources.push(series.getSources());
        }

        return Object.assign({}, this.seriesBase, {
            customdata: sources,   // https://plotly.com/javascript/reference/heatmap/#heatmap-customdata
            x,
            y,
            z,
        });
    }
}

export default PlotlyHeatmapSeriesMapper;